import React, { useState, useEffect } from "react";
import {
  Dialog,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  Grid,
  Box,
  Typography,
} from "@mui/material";
import { IoMdClose, IoMdSave } from "react-icons/io";
import productService from "../../services/productService";

const PriceModal = ({ open, onClose, initialPrices, onSave }) => {
  const [localPrices, setLocalPrices] = useState({});
  const [marketplaces, setMarketplaces] = useState([]);

  useEffect(() => {
    setLocalPrices(initialPrices || {});
  }, [initialPrices]);

  useEffect(() => {
    const fetchMarketAndEcommercePlaces = async () => {
      try {
        const marketResponse = await productService.fetchMarketPlaces();
        const ecommerceResponse = await productService.fetchEcommercePlaces();

        const marketData = Array.isArray(marketResponse.data.data)
          ? marketResponse.data.data
          : marketResponse.data.marketplaces || [];
        const ecommerceData = Array.isArray(ecommerceResponse.data.data)
          ? ecommerceResponse.data.data
          : ecommerceResponse.data.marketplaces || [];

        const combinedData = [
          ...marketData.map((item) => ({ ...item, source: "marketplace" })),
          ...ecommerceData.map((item) => ({ ...item, source: "ecommerce" })),
        ];

        setMarketplaces(
          combinedData.map((item) => ({
            id: item.id,
            name: item.name,
            color: item.colorCode || "#000",
            fields: item.fields || ["Piyasa(Liste Fiyatı)", "Satış Fiyatı"],
          }))
        );
      } catch (error) {
        console.error("Error fetching marketplaces:", error);
      }
    };

    fetchMarketAndEcommercePlaces();
  }, []);

  const handleLocalChange = (marketplace, field, value) => {
    const updatedPrices = {
      ...localPrices,
      [marketplace]: {
        ...localPrices[marketplace],
        [field]: value,
      },
    };
    setLocalPrices(updatedPrices);
  };

  const handleSave = () => {
    onSave(localPrices);
    onClose();
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      fullWidth
      maxWidth="md"
      PaperProps={{
        sx: {
          borderRadius: "12px",
          overflow: "hidden",
          padding: "16px",
        },
      }}
    >
      <Box sx={{ display: "flex", alignItems: "center", mb: 2 }}>
        <Box sx={{ width: 4, height: 24, backgroundColor: "#b71c1c", mr: 1 }} />
        <Typography variant="h6" color="black">
          Fiyatlandırmaları Düzenle
        </Typography>
      </Box>
      <DialogContent
        sx={{
          padding: 2,
          backgroundColor: "#fff",
          borderRadius: 2,
          boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
          maxHeight: "800px",
          overflowY: "auto",
          height: "100%",
        }}
      >
        <Grid container spacing={3}>
          {marketplaces.map((marketplace, index) => (
            <Grid item xs={12} md={6} key={index}>
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  gap: 2,
                  backgroundColor: "#f9f9f9",
                  borderRadius: "8px",
                  padding: "16px",
                }}
              >
                <Typography
                  variant="subtitle1"
                  fontWeight="bold"
                  color={marketplace.color}
                >
                  {marketplace.name}
                </Typography>
                {marketplace.fields.map((field, fieldIndex) => (
                  <TextField
                    size="small"
                    key={fieldIndex}
                    label={field}
                    variant="outlined"
                    fullWidth
                    type="number"
                    value={localPrices[marketplace.name]?.[field] || ""}
                    onChange={(e) =>
                      handleLocalChange(marketplace.name, field, e.target.value)
                    }
                    sx={{
                      backgroundColor: "#fff",
                      borderRadius: "4px",
                    }}
                  />
                ))}
              </Box>
            </Grid>
          ))}
        </Grid>
      </DialogContent>
      <DialogActions
        sx={{
          justifyContent: "flex-end",
          padding: "16px",
        }}
      >
        <Button
          onClick={onClose}
          variant="outlined"
          startIcon={<IoMdClose />}
          sx={{
            color: "#29275D",
            borderColor: "#29275D",
            textTransform: "none",
            borderRadius: "20px",
            marginRight: 2,
            "&:hover": {
              backgroundColor: "#f1f1f1",
            },
          }}
        >
          Kapat
        </Button>

        <Button
          onClick={handleSave}
          variant="contained"
          startIcon={<IoMdSave />}
          sx={{
            borderRadius: 18,
            backgroundColor: "#1F1B45",
            color: "#FFFFFF",
            textTransform: "none",
            fontWeight: 500,
            fontSize: "0.875rem",
            padding: "10px 20px",
            display: "flex",
            alignItems: "center",
            gap: 1,
            "&:hover": {
              backgroundColor: "#2C285A",
            },
          }}
        >
          Kaydet
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default PriceModal;
